export default __webpack_public_path__ + "static/media/care_device_pin2.06f0b801.svg";